// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityTableImportMutationVariables = Types.Exact<{
  inputs: Array<Types.AugmentedCreateEntityInput> | Types.AugmentedCreateEntityInput;
}>;


export type EntityTableImportMutation = { __typename?: 'Mutation', createEntities: Array<{ __typename?: 'Entity', id: string } | null> };

export const Operations = {
  Mutation: {
    EntityTableImport: 'EntityTableImport' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const EntityTableImportDocument = gql`
    mutation EntityTableImport($inputs: [AugmentedCreateEntityInput!]!) {
  createEntities(input: $inputs) {
    id
  }
}
    `;
export type EntityTableImportMutationFn = Apollo.MutationFunction<EntityTableImportMutation, EntityTableImportMutationVariables>;

/**
 * __useEntityTableImportMutation__
 *
 * To run a mutation, you first call `useEntityTableImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityTableImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityTableImportMutation, { data, loading, error }] = useEntityTableImportMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useEntityTableImportMutation(baseOptions?: Apollo.MutationHookOptions<EntityTableImportMutation, EntityTableImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityTableImportMutation, EntityTableImportMutationVariables>(EntityTableImportDocument, options);
      }
export type EntityTableImportMutationHookResult = ReturnType<typeof useEntityTableImportMutation>;
export type EntityTableImportMutationResult = Apollo.MutationResult<EntityTableImportMutation>;
export type EntityTableImportMutationOptions = Apollo.BaseMutationOptions<EntityTableImportMutation, EntityTableImportMutationVariables>;